import React, { useEffect, useState } from "react";
import { LangLink as Link } from "@/components/LangLink";
import SEO from "@/components/SEO";
import PageHeader from "@/components/PageHeader";
import { api } from "@/lib/api";
import { formatDateEU } from "@/lib/date";

export default function Blog() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/blog/posts").then((r) => setPosts(r.data || [])).catch(() => setPosts([])).finally(() => setLoading(false));
  }, []);

  return (
    <>
      <SEO
        title="Blog Akomoda — Hotelerinë në praktikë"
        description="Artikuj, udhëzues dhe analiza për menaxhimin e hoteleve, channel manager, booking engine dhe çmimet — në gjuhën shqipe."
      />
      <PageHeader
        eyebrow="Blog"
        title="Praktika dhe ide nga hotelerinë"
        description="Udhëzues, raste praktike dhe analiza për pronarët dhe menaxherët e hoteleve në Shqipëri dhe Ballkan."
        breadcrumb={[{ label: "Blog" }]}
      />

      <section className="bg-surface-1">
        <div className="container-akm py-14 md:py-20">
          {loading ? (
            <div className="text-sm text-slate2">Duke ngarkuar…</div>
          ) : posts.length === 0 ? (
            <div className="card-akm" data-testid="blog-empty">
              <div className="font-display text-base font-bold text-ink">Së shpejti</div>
              <p className="mt-2 text-sm text-slate2">
                Po përgatisim artikujt e parë — për PMS, channel manager, booking engine dhe çmimet. Kthehuni së shpejti.
              </p>
              <Link to="/demo" className="btn-primary mt-4">Ndërkohë, kërkoni një demo</Link>
            </div>
          ) : (
            <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
              {posts.map((p) => (
                <Link
                  key={p.id}
                  to={`/blog/${p.slug}`}
                  className="group overflow-hidden rounded-xl border border-line bg-white shadow-card transition-shadow hover:shadow-hover"
                  data-testid={`blog-card-${p.slug}`}
                >
                  {p.cover_image ? (
                    <div className="aspect-[16/9] w-full overflow-hidden bg-bg">
                      <img src={p.cover_image} alt={p.title} className="h-full w-full object-cover" loading="lazy" />
                    </div>
                  ) : (
                    <div className="aspect-[16/9] w-full bg-gradient-to-br from-bg to-line" />
                  )}
                  <div className="p-5">
                    {(p.tags || []).slice(0, 2).map((t) => (
                      <span key={t} className="mr-1 inline-flex rounded-full border border-line bg-bg px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wider text-slate2">{t}</span>
                    ))}
                    <h2 className="mt-2 font-display text-lg font-bold leading-snug text-ink group-hover:text-[#FF7A00]">{p.title}</h2>
                    {p.excerpt && <p className="mt-2 line-clamp-3 text-sm text-slate2">{p.excerpt}</p>}
                    <div className="mt-3 text-xs text-slate2">{formatDateEU(p.created_at)}</div>
                  </div>
                </Link>
              ))}
            </div>
          )}
        </div>
      </section>
    </>
  );
}
